import Modal from 'react-bootstrap/Modal';
import { useEffect, useState } from 'react';

type Props = {
  show: boolean;
  hide: () => void;
  details: any;
};

const url = process.env.REACT_APP_MENU_IMAGE_URL;

function ViewMenuItemModal({ show, hide, details }: Props) {
  const [selectedMenuItem, setSelectedMenuItem] = useState<any>({});

  useEffect(() => {
    if (show && details) {
      setSelectedMenuItem(details);
    }
  }, [details, show]);

  const remainingStock = selectedMenuItem ? 
    (selectedMenuItem.stockQuantity || 0) - (selectedMenuItem.soldQuantity || 0) - (selectedMenuItem.givenQuantity || 0) 
    : 0;

  return (
    <Modal show={show} onHide={hide} size="xl" centered>
      <Modal.Body>
        <div className='customer-details-title-ctn'>
          <span className='customer-details-title'>{selectedMenuItem?.deviceName || selectedMenuItem?.name}</span>
        </div>

        <div className='item-details-row-container'>
          <div className='row-container'>
            <div className='column-item'>
              <span className='key'>Category</span>
              <span className='value'>{selectedMenuItem?.type || selectedMenuItem?.category}</span>
            </div>
            <div className='column-item'>
              <span className='key'>Item Name</span>
              <span className='value'>{selectedMenuItem?.deviceName || selectedMenuItem?.name}</span>
            </div>
            <div className='column-item'>
              <span className='key'>Price</span>
              <span className='value'>Rwf {selectedMenuItem?.price}</span>
            </div>
          </div>
        </div>

        <div className='item-details-row-container'>
          <div className='row-container'>
            <div className='column-item'>
              <span className='key'>Availability</span>
              <span className='value'>
                <span
                  className={`px-2 py-1 rounded-full text-xs font-medium ${
                    selectedMenuItem?.isAvailable
                      ? 'bg-green-100 text-green-800'
                      : 'bg-red-100 text-red-800'
                  }`}
                  style={{ display: 'inline-block' }}
                >
                  {selectedMenuItem?.isAvailable ? 'Available' : 'Not Available'}
                </span>
              </span>
            </div>
            <div className='column-item'>
              <span className='key'>Stock Quantity</span>
              <span className='value'>{selectedMenuItem?.stockQuantity || 0}</span>
            </div>
            <div className='column-item'>
            </div>
          </div>
        </div>

        <div className='item-details-row-container'>
          <div className='row-container'>
            <div className='column-item'>
              <span className='key'>Sold Items</span>
              <span className='value' style={{ color: '#2563eb', fontWeight: '600' }}>{selectedMenuItem?.soldQuantity || 0}</span>
            </div>
            <div className='column-item'>
              <span className='key'>Given Items</span>
              <span className='value' style={{ color: '#10b981', fontWeight: '600' }}>{selectedMenuItem?.givenQuantity || 0}</span>
            </div>
            <div className='column-item'>
              <span className='key'>Remaining Stock</span>
              <span className='value' style={{ 
                color: remainingStock < 10 ? '#ef4444' : '#000',
                fontWeight: '600'
              }}>
                {remainingStock}
                {remainingStock < 10 && ' (Low Stock!)'}
              </span>
            </div>
          </div>
        </div>

        {selectedMenuItem?.images && selectedMenuItem.images.length > 0 && (
          <div className='item-details-row-container'>
            <div className='row-container'>
              <div className='column-item' style={{ width: '100%' }}>
                <span className='key'>Product Images</span>
                <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginTop: '12px' }}>
                  {selectedMenuItem.images.map((el: any, index: number) => (
                    <div key={`image-${el.id || el._id || index}`}>
                      <img 
                        src={url + el.url.replace(/^\/uploads/, "")} 
                        width={150} 
                        height={150} 
                        style={{ objectFit: 'cover', borderRadius: '8px', border: '1px solid #e5e5e5' }}
                        alt={`${selectedMenuItem.deviceName || selectedMenuItem.name} - Image ${index + 1}`} 
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ViewMenuItemModal;